import React from 'react';

type Props = JSX.IntrinsicAttributes
    & React.ClassAttributes<HTMLTableRowElement>
    & React.HTMLAttributes<HTMLTableRowElement>;

const ClickableTr = (props: Props): JSX.Element => <tr {...props} />;

export default ClickableTr;
